import script from "./AssetableDatatable.vue?vue&type=script&lang=js"
export * from "./AssetableDatatable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/assets/AssetableDatatable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "409c674d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('409c674d', __exports__)) {
    console.log('reload')
    api.reload('409c674d', __exports__)
  }
  
}


export default __exports__